export default __webpack_public_path__ + "static/media/products-no-image.703351db.jpg";